import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ModelSelectionUndoState } from '../ModelSelectionPage';
import { StoreState } from '../../../store/store';
import { ModelType } from '../../../store/global-types/customization-types';
import AeTitleRuleForm from '../AeTitleRuleForm';
import { aeTitleRuleActionUpdated, aeTitleRuleRemoved, imageSelectors } from '../../../store/image/imageSlice';
import { makeSelectFormValidationErrorsForAeTitleRule } from '../../../store/image/imageSelectors';
import { AETITLE_PREFIX_IMAGE } from '../../../store/image/image-types';



interface ImageAeTitleRuleProps {
    aeTitleRuleId: string,
    runningNumber: number,
    isLastRule: boolean,
    setUndoState: (undoState: ModelSelectionUndoState) => void,
    isUndoDisabled?: boolean,
}

const ImageAeTitleRule = (props: ImageAeTitleRuleProps) => {
    const { aeTitleRuleId, runningNumber, isLastRule, setUndoState, isUndoDisabled } = props;

    const dispatch = useDispatch();

    const aeTitleRule = useSelector((state: StoreState) => imageSelectors.selectAeTitleRuleById(state, aeTitleRuleId));
    const validationError = useSelector((state: StoreState) => imageSelectors.selectCustomizationValidationError(state, aeTitleRuleId));
    const selectFormValidationErrorsForRule = makeSelectFormValidationErrorsForAeTitleRule();
    const formValidationErrors = useSelector((state: StoreState) => selectFormValidationErrorsForRule(state, aeTitleRuleId));

    const handleAeTitleActionChanged = useCallback((action: string) => {
        dispatch(aeTitleRuleActionUpdated({ id: aeTitleRuleId, action }));
    }, [dispatch, aeTitleRuleId]);


    const handleAeTitleRemoved = useCallback(() => {
        dispatch(aeTitleRuleRemoved(aeTitleRuleId));
    }, [dispatch, aeTitleRuleId]);


    // don't render anything if we don't have a valid object
    if (aeTitleRule === undefined) {
        return null;
    }

    return (
        <AeTitleRuleForm
            aeTitleRule={aeTitleRule}
            prefix={AETITLE_PREFIX_IMAGE}
            modelType={ModelType.Image}
            onAeTitleRuleActionUpdated={handleAeTitleActionChanged}
            onAeTitleRuleRemoved={handleAeTitleRemoved}
            runningNumber={runningNumber}
            isLastRule={isLastRule}
            setUndoState={setUndoState}
            validationError={validationError}
            formValidationErrors={formValidationErrors}
            isUndoDisabled={isUndoDisabled}
         />
    );
}

export default ImageAeTitleRule;
